import React, { useEffect, useState } from "react";
import CustomTabs from "../components/CustomTabs/CustomTabs";
import Overview from "../components/Reporting/Overview";
import TopPerformers from "../components/Reporting/TopPerformers";
import LeastPerformers from "../components/Reporting/LeastPerformer";
import StudentAboveTarget from "../components/Reporting/StudentAboveTarget";
import StudentBelowTarget from "../components/Reporting/StudentBelowTarget";
import GHeader from "../components/GeneralHeader/GHeader";
import NotAccess from "./NotAccess";
import { checkRoutePermissions } from "../utils/permission";
import { getAllClasses } from "../store/services/class";
import { getSubjectAll } from "../store/services/subject";
const Reporting = () => {
  const [activeItem, setActiveItem] = useState("Overview");
  const list = [
    "Overview",
    "Top Performers",
    "Lowest Performers",
    "Students Above Target",
    "Students Below Target",
  ];

  useEffect(() => {
    _getData();
  }, []);

  const _getData = async () => {
    await getAllClasses({ withData: false, status: "active" });
    // await getSubjectAll({ status: "active" });
  };

  return checkRoutePermissions("reportingPage") ? (
    <div className="mainDiv responsive">
      <GHeader
        heading="Reporting"
        headingText="Review top and least performers , students above and below target."
      />
      <div className="settingMin">
        <CustomTabs
          list={list}
          setActiveItem={setActiveItem}
          activeItem={activeItem}
        />
        {/* <div className="reporting "> */}
        {activeItem === "Overview" ? (
          <Overview />
        ) : activeItem === "Top Performers" ? (
          <TopPerformers />
        ) : activeItem === "Lowest Performers" ? (
          <LeastPerformers />
        ) : activeItem === "Students Above Target" ? (
          <StudentAboveTarget />
        ) : activeItem === "Students Below Target" ? (
          <StudentBelowTarget />
        ) : (
          ""
        )}
        {/* </div> */}
      </div>
    </div>
  ) : (
    <NotAccess />
  );
};

export default Reporting;
